import { useQuery } from '@tanstack/react-query';
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { TipRewardClaimScreen } from '../features/tip-reward-claim/ui/tip-reward-claim-screen';
import { getTipperEmployeeProfile } from '../shared/api/tipper.service';
import { ViewportFrame, ViewportPage } from '../shared/ui';

import {
  resolveTipThanksRewardAmount,
  type TipThanksPageLocationState,
} from './tip-thanks-page.state';

export function TipThanksPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { walletUUID } = useParams();
  const { data: recipientProfile } = useQuery({
    enabled: typeof walletUUID === 'string' && walletUUID.length > 0,
    queryFn: () => getTipperEmployeeProfile(walletUUID as string),
    queryKey: ['tipper', 'employee-profile', walletUUID],
  });

  if (!walletUUID) {
    return <Navigate replace to="/home" />;
  }

  const rewardAmount = resolveTipThanksRewardAmount(
    walletUUID,
    location.state as TipThanksPageLocationState | null,
  );

  return (
    <ViewportPage dataUi="tip-thanks-page">
      <ViewportFrame
        dataUi="tip-thanks-page-frame"
        paddingBottomPx={28}
        paddingLeftPx={30}
        paddingRightPx={30}
        paddingTopPx={20}
      >
        <TipRewardClaimScreen
          isActionsDisabled
          onClaimGift={() => navigate('/login')}
          onOpenAccount={() => navigate('/login')}
          recipientFirstName={recipientProfile?.firstName}
          rewardAmount={rewardAmount}
        />
      </ViewportFrame>
    </ViewportPage>
  );
}
